<template>
    <x-container pa-0>
        <x-layout mb-4>
            <x-flex xs6>
                <data-list v-model="dataList" />
            </x-flex>
        </x-layout>

        <x-layout v-if="!isStandalonePolicy">
            <x-flex xs6>
                <entity-field :entities="entities" :submission="submission" />
            </x-flex>
        </x-layout>
    </x-container>
</template>


<script>
import EntityField from "~/components/Broker/UIComponents/EntityField";
import DataList from "~/components/Shared/UIComponents/DataList";
import submissionHelpers from "~/mixins/submissionHelpers";

export default {
    name: "EntitySummary",
    components: {
        EntityField,
        DataList
    },
    mixins: [submissionHelpers],
    props: ["submission"],
    computed: {
        entities() {
            if (this.isStandalonePolicy) {
                return this.submission.client_company.entities;
            }

            return this.submission.facility?.active_entities || [];
        },
        dataList() {
            const list = [
                {
                    text: "Client",
                    value: this.submission.client_company.name,
                },
            ];

            if (this.submission.risk_structure === 'accepted_declaration') {
                list.push({
                    text: "Facility",
                    value: this.submission?.facility?.name || "No facility",
                });
            }

            return list;
        }
    },
};
</script>
